import styled from 'styled-components'
import { NoPaddingCol } from 'Components/EnhacedFlexboxGrid'
import { BREAK_POINT_LG } from '@CSSVars/variables'
import { OUTLINE_COLOR } from '@CSSVars/colors'

export const _SideMenuCol = styled(NoPaddingCol)`
  flex: 0.3;
  min-width: 300px;
  max-width: 360px;
  @media screen and (min-width: ${BREAK_POINT_LG}) {
    flex: 0.4;
    width: 360px;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
    min-width: 256px;
    max-width: 256px;
  }
`

export const _LinkContainer = styled.div`
  border-top:  1px solid ${OUTLINE_COLOR};
  border-left: 1px solid ${OUTLINE_COLOR};
  border-right: 1px solid ${OUTLINE_COLOR};
`
